<template>
<div>




<!-- navigation pannel-->
<nav id="header" 
      class="navbar navbar-expand-lg navbar-light bg-info rounded" 
      style="background-color: #e3f2fd;">
  
  <a class="navbar-brand" href="#"><i class="fas fa-horse"></i></a>


  <button class="navbar-toggler" 
          type="button" 
          data-toggle="collapse" 
          data-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>


  <div class="collapse navbar-collapse " 
        id="navbarNav">
    <ul class="navbar-nav ml-auto mr-auto">
      <li class="nav-item">
            <router-link tag="li" 
                to="./AboutUs"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light"
                >{{aboutUs}}</router-link>
      </li>
      <li class="nav-item active">
        <router-link tag="li" 
                to="/"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light"
                >{{news}}</router-link>
      </li>
      <li class="nav-item">
        <router-link tag="li" 
                to="./History"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light">{{history}}</router-link>
      </li>
      <li class="nav-item">
        <router-link tag="li" 
                to="./ClubUnion"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light">{{clubsAndUnions}}</router-link>
      </li>
      <li class="nav-item">
        <router-link tag="li" 
                to="./Turism"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light">{{tourismAndAdventure}}</router-link>
      </li>
      <li class="nav-item">
        <router-link tag="li" 
                to="./Contact"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light">{{contactUs}}</router-link>
      </li>  
      <li class="nav-item">
        <router-link tag="li" 
                to="./AbautHorses"
                :style="{ cursor: 'pointer'}"
                class="nav-link text-center text-light">{{abautHorses}}</router-link>
      </li>          


    </ul>
    <!-- <form class=" form-group-xs row form-inline ml-auto my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="form-control btn btn-outline-light mr-3 my-2 my-sm-0 text-center" type="submit">Search</button>
    </form> -->
  </div>
</nav>
</div>
</template>

<script>
  import jsonObjectHeader from './menuNameJSON/geHeader.json';
   
export default {
    props: ['langTitle'],

    data(){
        return{
          // Get JSON object from imported file
          jsonObjectHeader,

          // title Language place holder
          HorsSportGeorgia: jsonObjectHeader.enHorsSportGeorgia,
          // menu languege place holder
          aboutUs: jsonObjectHeader.aboutUs,
          news: jsonObjectHeader.news,
          history: jsonObjectHeader.history,
          clubsAndUnions: jsonObjectHeader.clubsAndUnions,
          tourismAndAdventure: jsonObjectHeader.tourismAndAdventure,
          contactUs: jsonObjectHeader.contactUs,
          abautHorses: jsonObjectHeader.aboutHorses,

          // News laguage place holder
          
        }
      },
   methods:{
    //  laguage change functions
    // Georgian Language
     geLangChange: function (){
        this.HorsSportGeorgia=jsonObjectHeader.geHorsSportGeorgia
        this.aboutUs= jsonObjectHeader.geAboutUs,
        this.News= jsonObjectHeader.geNews,
        this.History= jsonObjectHeader.geHistory,
        this.ClubsAndUnions= jsonObjectHeader.geClubsAndUnions,
        this.TourismAndAdventure= jsonObjectHeader.geTourismAndAdventure,
        this.ContactUs=jsonObjectHeader.geContactUs;

        this.langTitle=newsText.geNews
        eventBus.langWasEdited(this.langTitle);
        
        
     },
    //  English Language
    enLangChange: function (){
        this.HorsSportGeorgia=jsonObjectHeader.enHorsSportGeorgia
        this.aboutUs= jsonObjectHeader.enAboutUs,
        this.News= jsonObjectHeader.enNews,
        this.History= jsonObjectHeader.enHistory,
        this.ClubsAndUnions= jsonObjectHeader.enClubsAndUnions,
        this.TourismAndAdventure= jsonObjectHeader.enTourismAndAdventure,
        this.ContactUs=jsonObjectHeader.enContactUs
     },
    // Russian Language
    ruLangChange: function (){
        this.HorsSportGeorgia=jsonObjectHeader.ruHorsSportGeorgia,
        this.aboutUs= jsonObjectHeader.enAboutUs,
        this.News= jsonObjectHeader.ruNews,
        this.History= jsonObjectHeader.ruHistory,
        this.ClubsAndUnions= jsonObjectHeader.ruClubsAndUnions,
        this.TourismAndAdventure= jsonObjectHeader.ruTourismAndAdventure,
        this.ContactUs=jsonObjectHeader.ruContactUs
    }

   }

}
</script>

<style>
h4 {
  text-transform: capitalize !important;
}

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/Header.vue